module.exports = __webpack_public_path__ + "img/system6.284d8215.png";